<template>
  <el-select v-model="place" v-if="isRadio" @change="getCty" collapse-tags clearable placeholder="请选择送货地" size="small">
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
  <el-select v-model="place" v-else @change="getCty" multiple collapse-tags clearable placeholder="请选择送货地" size="small">
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "place",
  // 传值
  props: {
    places: { String },
    radio: { Boolean }
  },
  data() {
    return {
      options: [], //国家列表
      place: this.places,
      isRadio: this.radio
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init(){
      let that=this;
      //送货地查询
      httpApi
        .listParams({ params: { type: "sys_dispatch_place",enable: "1" } })
        .then(res => {
         if (res.data.code == "ok") {
          console.log(res.data.data);
        
          res.data.data.forEach(element => {
              that.options.push({ label: element.cname, value: element.id });
            });
        }
        });
      }
  },
  created() {
    this.init();
  },
  watch: {
    places: function(newVal) {
      this.place = newVal;
    }
  }
};
</script>

<style>
</style>